import CountUp from 'react-countup'
export default function NumberDelay({number, preserveValue = false, decimals = 0}: any) {
  return <CountUp preserveValue={preserveValue} decimals={decimals} end={number} />
}
